import { useMutation, useQuery } from "@tanstack/react-query";
import { handleError } from "@/api/error";
import { client } from "../client";

type CopySequencesPayload = {
  sourceMerchantId: string;
  targetMerchantId: string;
  sequenceIds?: string[];
  templateIds?: string[];
};

type CopySequencesResult = {
  messageTemplates: { oldId: string; newId: string; name: string }[];
  sequences: { oldId: string; newId: string; name: string }[];
  defaults: { triggerType: string; sequenceId: string }[];
};

export type SourceSequence = {
  id: string;
  name: string;
  type: string;
  dependentTemplateIds: string[];
};

export type SourceTemplate = {
  id: string;
  name: string;
  category: string;
};

export const useMerchantCopyData = (merchantId: string) => {
  return useQuery({
    queryKey: ["admin", "copy-sequences", "merchant", merchantId],
    queryFn: async () => {
      // biome-ignore lint/suspicious/noExplicitAny: Hono RPC type limit
      const res = await (client.admin as any)["copy-sequences"].merchant.$get({
        query: { merchantId },
      });
      if (!res.ok) throw await handleError(res);
      return (await res.json()) as { sequences: SourceSequence[]; messageTemplates: SourceTemplate[] };
    },
  });
};

export const useCopySequences = () => {
  return useMutation({
    mutationFn: async (payload: CopySequencesPayload) => {
      // biome-ignore lint/suspicious/noExplicitAny: Hono RPC type limit
      const res = await (client.admin as any)["copy-sequences"].$post({
        json: payload,
      });
      if (!res.ok) throw await handleError(res);
      return (await res.json()) as CopySequencesResult;
    },
  });
};
